import { Global } from '@emotion/react';
import { ConfigProvider } from 'antd';

import * as Style from './Select.style';

interface Props {
  options: { label: string; value: string }[];
  onOpenChange?: (open: boolean) => void;
  disabled?: boolean;
  onClick?: () => void;
}

const Select = ({ options, ...rest }: Props) => {
  return (
    <>
      <Global styles={Style.globalSelectStyles} />
      <ConfigProvider
        theme={{
          cssVar: true,
          hashed: false,
          token: {
            borderRadius: 0,
            colorBorder: '#0e2a27',
          },
          components: {
            Select: {
              selectorBg: 'transparent',
            },
          },
        }}
      >
        <Style.Select
          options={options}
          listHeight={400}
          variant="underlined"
          popupClassName="custom-questionnaire-select-dropdown"
          getPopupContainer={(trigger) => document.body}
          {...rest}
        />
      </ConfigProvider>
    </>
  );
};

export default Select;
